export default "__VITE_ASSET__9zvxJ6vG__"